module.exports = __webpack_public_path__ + "static/media/Ginkolet.c3f6edfb.svg";